<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} {{ aLang.tt_title }}</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} {{ aLang.tt_title }}</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} {{ aLang.tt_title }}</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-form-item :label="aLang.tt_tour" prop="tour_id">
                <el-select
                  v-if="mData.viewMode == 'detail' || mData.viewMode == 'update'"
                  :disabled="mData.viewMode == 'detail' || mData.viewMode == 'update'"
                  v-model="mData.dataForm.tour_id"
                  :placeholder="aLang.tt_enter_keywords_to_search"
                  @change="fn_selectData(mData.dataForm.tour_id)"
                  clearable
                  filterable
                  no-data-text="Chưa có dữ liệu"
                  :filter-method="fn_remoteGetListTour"
                  @keyup.enter.native="fn_remoteGetListTour"
                
                >
                  <el-option
                    v-for="item in mData.dataDefault.listTour"
                    :key="item.id"
                    :label="item.ten_tour"
                    :value="item.id"
                  ></el-option>
                </el-select>
              <!-- test autocomplete -->
                <el-autocomplete
                  v-if="mData.viewMode !== 'detail' && mData.viewMode !== 'update'"
                  :disabled="mData.viewMode == 'detail' || mData.viewMode == 'update'"
                  class="inline-input"
                  v-model="ten_tour"
                  :fetch-suggestions="querySearch"
                  :placeholder="aLang.tt_enter_keywords_to_search"
                  :trigger-on-focus="false"
                  @select="handleSelect"
                  @change="handleSelect"
                  clearable
                >
                  <template slot-scope="{ item }">
                    <span class="link">{{ item.ten_tour }}</span>
                  </template>
                </el-autocomplete>
              <!-- end test autocomplete -->

              </el-form-item>

            </b-col>

            <b-col md="3">
              <el-form-item
                :label="aLang.tt_start_time"
                prop="thoi_gian_bat_dau"
                class="label-required"
              >
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataForm.thoi_gian_bat_dau"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                ></el-date-picker>
                <!-- <span
                  class
                  v-if="mData.dataDefault.validErrorTime"
                >Thời gian bắt đầu phải lớn hơn hoặc bằng thời gian bắt đầu tour</span>-->
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item
                :label="aLang.tt_end_time"
                prop="thoi_gian_ket_thuc"
                class="label-required"
              >
                <el-date-picker
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataForm.thoi_gian_ket_thuc"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-row v-if="mData.viewMode != 'detail'">
                <b-col md="4">
                  <el-form-item :label="aLang.tt_find_tour_guide_by_card_number">
                    <!-- <el-select
                      v-model="mData.dataDefault.itemHuongDanVien"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                      filterable
                      placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)"
                      no-data-text="Chưa có dữ liệu"
                      :filter-method="fn_remoteGetListHuongDanVien"
                      @keyup.enter.native="fn_enterFindHuongDanVien()"
                      @change="fn_addHuongDanVien(mData.dataDefault.itemHuongDanVien)"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listHuongDanVien"
                        :key="item.id"
                        :label="item.ho_ten.ho_ten + ' - số thẻ '+ item.the_hdv.so_the"
                        :value="item"
                      ></el-option>
                    </el-select> -->

                    <el-autocomplete
                      clearable
                      class="inline-input"
                      v-model="mData.dataDefault.itemHuongDanVien"
                      :fetch-suggestions="querySearchHuongDanVienST"
                      :placeholder="aLang.tt_enter_keywords_to_search"
                      :trigger-on-focus="false"
                      @select="handleSelectHuongDanVienST"
                    >
                      <template slot-scope="{ item }">
                        <span class="link">{{ item.ho_ten.ho_ten + ' - số thẻ '+ item.the_hdv.so_the }}</span>
                      </template>
                    </el-autocomplete>
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item :label="aLang.tt_find_tour_guide_by_document_number">
                    <!-- <el-select
                      v-model="mData.dataDefault.itemHuongDanVien2"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                      filterable
                      placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)"
                      no-data-text="Chưa có dữ liệu"
                      :filter-method="fn_remoteGetListHuongDanVien2"
                      @keyup.enter.native="fn_enterFindHuongDanVien2()"
                      @change="fn_addHuongDanVien(mData.dataDefault.itemHuongDanVien2)"
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listHuongDanVien2"
                        :key="item.id"
                        :label="item.ho_ten.ho_ten + ' - số giấy tờ: '+ item.giay_to[0].so_giay_to"
                        :value="item"
                      ></el-option>
                    </el-select> -->

                    <el-autocomplete
                      clearable
                      class="inline-input"
                      v-model="mData.dataDefault.itemHuongDanVien2"
                      :fetch-suggestions="querySearchHuongDanVienSGT"
                      :placeholder="aLang.tt_enter_keywords_to_search"
                      :trigger-on-focus="false"
                      @select="handleSelectHuongDanVienSGT"
                    >
                      <template slot-scope="{ item }">
                        <span class="link">{{ item.ho_ten.ho_ten + ' - số giấy tờ: '+ item.giay_to[0].so_giay_to }}</span>
                      </template>
                    </el-autocomplete>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12" class="mb-2">{{aLang.tt_waiting_confirmed_tour_guide_list}}</b-col>
                <div class="col-md-12">
                  <el-table
                    :data="mData.dataDefault.listHuongDanVienTable"
                    border
                    max-height="440"
                    style="width: 100%; display: grid;"
                  >
                    <el-table-column
                      prop="ho_ten.ho_ten"
                      :label="aLang.tt_fullname"
                      min-width="200"
                      width="auto"
                    ></el-table-column>
                    <el-table-column
                      prop="the_hdv.so_the"
                      :label="aLang.tt_guide_card_number"
                      width="150"
                      align="right"
                    ></el-table-column>

                    <el-table-column
                      prop="ngay_sinh.ngay_sinh"
                      :label="aLang.tt_bod"
                      width="100"
                      align="center"
                      :formatter="fn_formatterDate"
                    ></el-table-column>
                    <el-table-column prop="email" :label="aLang.tt_email" width="150"></el-table-column>
                    <el-table-column prop="dien_thoai" :label="aLang.tt_phone" width="150" align="right"></el-table-column>
                    <el-table-column prop="quoc_tich.ten_quoc_tich" :label="aLang.tt_nationality" width="150"></el-table-column>

                    <el-table-column :label="aLang.c_action" align="center" width="100px">
                      <template slot-scope="scope">
                        <el-button
                          size="mini"
                          @click="fn_deleteHuongDanVien(scope.$index)"
                          v-b-popover.hover.left="aLang.c_delete"
                        >
                          <i class="icon-trash icons"></i>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </b-row>
              <b-row class="mt-3" v-if="mData.dataForm.huong_dan_vien_ids">
                <b-col md="12" class="mb-2">{{aLang.tt_confirmed_tour_guide_list}}</b-col>
                <div class="col-md-12">
                  <el-table
                    :data="mData.dataDefault.listHuongDanVienDaXacNhan"
                    border
                    max-height="440"
                    style="width: 100%; display: grid;"
                  >
                    <el-table-column
                      prop="ho_ten.ho_ten"
                      :label="aLang.tt_fullname"
                      min-width="200"
                      width="auto"
                    ></el-table-column>
                    <el-table-column
                      prop="the_hdv.so_the"
                      :label="aLang.tt_guide_card_number"
                      width="200"
                      align="right"
                    ></el-table-column>

                    <el-table-column
                      prop="ngay_sinh.ngay_sinh"
                      :label="aLang.tt_bod"
                      width="150"
                      align="center"
                      :formatter="fn_formatterDate"
                    ></el-table-column>
                    <el-table-column prop="email" :label="aLang.tt_email" width="200"></el-table-column>
                    <el-table-column prop="dien_thoai" :label="aLang.tt_phone" width="150" align="right"></el-table-column>
                    <el-table-column prop="quoc_tich.ten_quoc_tich" :label="aLang.tt_nationality" width="150"></el-table-column>
                  </el-table>
                </div>
              </b-row>
              <b-row class="mt-3">
                <b-col md="6">
                  <el-form-item class="mb-0" :label="aLang.tt_attached_files">
                    <el-upload
                      action
                      :auto-upload="false"
                      list-type="text"
                      :limit="mData.fileUploadOption.FileDinhKem.limit"
                      :accept="mData.fileUploadOption.FileDinhKem.accept"
                      :on-change="fn_uploadChangeFileDinhKem"
                      :on-preview="fn_uploadPreviewFileDinhKem"
                      :on-remove="fn_uploadRemoveFileDinhKem"
                      :on-exceed="fn_uploadExceedFileDinhKem"
                      :file-list="mData.fileUploadOption.FileDinhKem.fileList"
                    >
                      <el-button size="small" type="info" plain v-if="mData.viewMode != 'detail'">
                        <i class="fa fa-upload"></i> Upload file
                      </el-button>
                    </el-upload>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import PhieuDieuTourModel from "./PhieuDieuTourModel";
import PhieuDieuTourApi from "../../../moduleApi/PhieuDieuTourApi";
import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
import TourApi from "../../../moduleApi/TourApi";
import FileApi from "../../../moduleApi/FileApi";
import CongTyLuHanhApi from "../../../moduleApi/CongTyLuHanhApi";
import ValidService from "../../../service/ValidService";

export default {
  data() {
    var validateTime = (rule, value, callback) => {
      let _error = 0; //Lỗi trả về 0,1,2
      let timeStart = this.mData.dataForm.thoi_gian_bat_dau;
      let timeEnd = this.mData.dataForm.thoi_gian_ket_thuc;

      let timeStartTour = this.mData.dataDefault.thoi_gian_bat_dau_tour;
      let timeEndTour = this.mData.dataDefault.thoi_gian_ket_thuc_tour;

      if (timeStart && timeEnd) {
        let time1 = "";
        let time2 = "";

        if (typeof timeStart == "string") {
          time1 = new Date(timeStart);
        }
        if (typeof timeEnd == "string") {
          time2 = new Date(timeEnd);
        }

        if (time1.getTime() > time2.getTime()) {
          _error = 1;
        }
      }

      if (timeStart && timeStartTour && timeEndTour) {
        let time3 = "";
        let time4 = "";
        let time41 = "";

        if (typeof timeStart == "string") {
          time3 = new Date(timeStart);
        }
        if (typeof timeStartTour == "string") {
          time4 = new Date(timeStartTour);
        }
        if (typeof timeEndTour == "string") {
          time41 = new Date(timeEndTour);
        }

        if (
          time3.getTime() < time4.getTime() ||
          time3.getTime() > time41.getTime()
        ) {
          _error = 3;
        }
      }
      if (timeStartTour && timeEndTour && timeEnd) {
        let time5 = "";
        let time6 = "";
        let time51 = "";

        if (typeof timeEndTour == "string") {
          time5 = new Date(timeEndTour);
        }
        if (typeof timeEnd == "string") {
          time6 = new Date(timeEnd);
        }
        if (typeof timeStartTour == "string") {
          time51 = new Date(timeStartTour);
        }

        if (
          time5.getTime() < time6.getTime() ||
          time51.getTime() > time6.getTime()
        ) {
          _error = 3;
        }
      }

      if (_error == 0) {
        callback();
      } else if (_error == 1) {
        callback(new Error(LanguageService.lang.valid_compareTime));
      } else if (_error == 2) {
        callback(new Error(LanguageService.lang.valid_required));
      } else if (_error == 3) {
        callback(new Error(LanguageService.lang.valid_compareStartEndTime));
      }
    };
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      tabIndex: [0, 0],
      mData: {
        viewMode: "create",
        moduleName: "PhieuDieuTour",
        dataDefault: {
          roles: DataService.rolesInForm,
          listProvince: [],
          listDistrict: [],
          listTour: [],
          textFindHuongDanVien: "",
          textFindHuongDanVien2: "",
          listHuongDanVien: [],
          listHuongDanVien2: [],
          listHuongDanVienDaXacNhan: [],
          itemHuongDanVien: null,
          itemHuongDanVien2: null,
          listHuongDanVienTable: [],
          validErrorTime: false,
          // validErrorStartTime: false,
          // validErrorEndTime: false,
          thoi_gian_bat_dau_tour: "",
          thoi_gian_ket_thuc_tour: ""
        },
        dataForm: MethodService.copyObject(PhieuDieuTourModel.dataForm),
        validForm: {
          tour_id: [ValidService.requiredChange], //IdRef, required // Mã tour
          huong_dan_vien_cho_xac_nhan_ids: [ValidService.required], //array of IdRef, optional // Danh sách mã hướng dẫn viên
          thoi_gian_bat_dau: [ValidService.requiredChange], //datetime, optional // Thời gian bắt đầu
          thoi_gian_ket_thuc: [
            ValidService.requiredChange,
            { validator: validateTime, trigger: "blur" }
          ], //datetime, optional // Thời gian kết thúc
          file_dinh_kem_ids: [] //array of IdRef, optional // Danh sách mã các file đính kèm
        },
        dialog: {},
        fileUploadOption: {
          FileDinhKem: {
            limit: null,
            accept: "",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
          }
        }
      },
        ten_tour:'',
        so_the_huong_dan_vien:'',
        so_giay_to_huong_dan_vien:''
    };
  },
  methods: {

    async querySearch(queryString, cb) {
      queryString = queryString.trim();
      let query1 = queryString
        .replace("*", "\\*")
        .replace("$", "\\$")
        .replace("%", "\\*")
        .replace("[", "\\[")
        .replace("]", "\\]")
        .replace("^", "\\^");
      let resTourApi = await TourApi.list({
        limit: 1000,
        filters: `ten_tour:regex_i:${query1}`
      });
      this.mData.dataDefault.listTour = await resTourApi.result;

      var results =  queryString ? resTourApi.result.filter(item=>item.ten_tour.toLowerCase().includes(queryString.toLowerCase())) : resTourApi.result
      // call callback function to return suggestions
      cb(results);

    },
    handleSelect(item) {
      this.fn_selectData(item.id);
      this.mData.dataForm.tour_id=item.id
      this.ten_tour = item.ten_tour;
    },
    async querySearchHuongDanVienST(queryString, cb) {
      queryString = queryString.trim();
      let resHuongDanVienApi = await HuongDanVienApi.list({
        filters: `the_hdv.trang_thai=true&the_hdv.so_the=${encodeURIComponent(queryString)}`
      });
      // console.log('resHuongDanVienApi',resHuongDanVienApi);

      var results =  queryString ? resHuongDanVienApi.result.filter(item=>item.the_hdv.so_the.includes(queryString)) : resHuongDanVienApi.result
      // call callback function to return suggestions
      cb(results);

    },
    handleSelectHuongDanVienST(item) {
      this.mData.dataDefault.itemHuongDanVien = item
      this.so_the_huong_dan_vien = item.ho_ten.ho_ten + ' - số thẻ '+ item.the_hdv.so_the;
      this.fn_addHuongDanVien(this.mData.dataDefault.itemHuongDanVien)
   },
    async querySearchHuongDanVienSGT(queryString, cb) {
      queryString = queryString.trim();
      let resHuongDanVienApi = await HuongDanVienApi.list({
        filters: `the_hdv.trang_thai=true&giay_to.so_giay_to=${encodeURIComponent(queryString)}`
      });
      // console.log('resHuongDanVienApi 2',resHuongDanVienApi);

      var results =  queryString ? resHuongDanVienApi.result.filter(item=>item.giay_to[0].so_giay_to.includes(queryString)) : resHuongDanVienApi.result
      // call callback function to return suggestions
      cb(results);

    },
    handleSelectHuongDanVienSGT(item) {
      this.mData.dataDefault.itemHuongDanVien2 = item
      this.so_giay_to_huong_dan_vien = item.ho_ten.ho_ten + ' - số giấy tờ: '+ item.giay_to[0].so_giay_to;
      this.fn_addHuongDanVien(this.mData.dataDefault.itemHuongDanVien2)
   },   
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          if (type == "create") {
            let checkTour = 0;
            let checkTourAgent = 0;
            // get TourAgent disabled
            let resLock = await CongTyLuHanhApi.list({
              filters: "id=$$cong_ty_lu_hanh_id"
            });
            if (
              resLock.result &&
              resLock.result.length > 0 &&
              resLock.result[0].isDisabled
            ) {
              checkTourAgent = 1;
            } else {
              checkTourAgent = 0;
            }

            //Kiểm tra đã có phiếu điều tour cho tour và hướng dẫn viên cùng 1 thời điểm

            let hdvChoXacNhans = MethodService.findListItemDifferent(
              this.mData.dataDefault.listHuongDanVienTable,
              "id"
            );

            let reqCheckHDV = await PhieuDieuTourApi.list({
              limit: 1000,
              filters:
                "tour_id:in:" +
                this.mData.dataForm.tour_id +
                "&" +
                "thoi_gian_bat_dau=" +
                this.mData.dataForm.thoi_gian_bat_dau +
                "&" +
                "thoi_gian_ket_thuc=" +
                this.mData.dataForm.thoi_gian_ket_thuc +
                "&" +
                "huong_dan_vien_cho_xac_nhan_ids:in:" +
                hdvChoXacNhans.join(",")
            });
            if (reqCheckHDV.result && reqCheckHDV.result.length > 0) {
              checkTour = 1;
            } else {
              if (checkTourAgent == 1) {
                checkTour = 2;
              } else {
                // checkTour = 0;
              }
            }

            let reqCheckHDVDaXacNhan = await PhieuDieuTourApi.list({
              limit: 1000,
              filters:
                "tour_id:in:" +
                this.mData.dataForm.tour_id +
                "&" +
                "thoi_gian_bat_dau=" +
                this.mData.dataForm.thoi_gian_bat_dau +
                "&" +
                "thoi_gian_ket_thuc=" +
                this.mData.dataForm.thoi_gian_ket_thuc +
                "&" +
                "huong_dan_vien_ids:in:" +
                hdvChoXacNhans.join(",")
            });
            if (
              reqCheckHDVDaXacNhan.result &&
              reqCheckHDVDaXacNhan.result.length > 0
            ) {
              checkTour = 1;
            } else {
              if (checkTourAgent == 1) {
                checkTour = 2;
              } else {
                // checkTour = 0;
              }
            }
            if (checkTour == 2) {
              window.toastr.error(
                "Công ty lữ hành bị khóa không thể thêm phiếu điều tour với các tour chưa bắt đầu"
              );
            } else if (checkTour == 1) {
              window.toastr.error(
                "Đã tồn tại phiếu điều tour cho tour và hướng dẫn viên tại thời điểm này"
              );
            } else if (checkTour == 0) {
              await PhieuDieuTourApi.create(
                this.mData.dataForm
              );
              this.fn_resetForm();
              this.fn_go(-1);
            }
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await PhieuDieuTourApi.update(this.mData.dataForm);
            // this.fn_go(-1);
          }
        } else {
          window.toastr.warning("Một số trường chưa nhập đúng thông tin");
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
      this.mData.dataDefault.listHuongDanVienTable = [];
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await PhieuDieuTourApi.findById(id);
      if (
        res.result.huong_dan_vien_cho_xac_nhan_ids &&
        res.result.huong_dan_vien_cho_xac_nhan_ids.length > 0
      ) {
        let listHuongDanVien = await HuongDanVienApi.list({
          limit: res.result.huong_dan_vien_cho_xac_nhan_ids.length,
          filters:
            "id:in:" + res.result.huong_dan_vien_cho_xac_nhan_ids.join(",")
        });
        for (var itemData in listHuongDanVien.result) {
          listHuongDanVien.result[itemData].ngay_sinh.ngay_sinh = new Date(
            listHuongDanVien.result[itemData].ngay_sinh.nam,
            listHuongDanVien.result[itemData].ngay_sinh.thang - 1,
            listHuongDanVien.result[itemData].ngay_sinh.ngay
          ).toJSON();
        }
        this.mData.dataDefault.listHuongDanVienTable = listHuongDanVien.result;
      }
      if (
        res.result.huong_dan_vien_ids &&
        res.result.huong_dan_vien_ids.length > 0
      ) {
        let listHuongDanVienDaXacNhan = await HuongDanVienApi.list({
          limit: res.result.huong_dan_vien_ids.length,
          filters: "id:in:" + res.result.huong_dan_vien_ids.join(",")
        });
        listHuongDanVienDaXacNhan.result.forEach((element) => {
          element.ngay_sinh.ngay_sinh = new Date(
            element.ngay_sinh.nam,
            element.ngay_sinh.thang - 1,
            element.ngay_sinh.ngay
          ).toUTCString();
        });
        this.mData.dataDefault.listHuongDanVienDaXacNhan =
          listHuongDanVienDaXacNhan.result;
      }
      if (
        res.result.file_dinh_kem_ids &&
        res.result.file_dinh_kem_ids.length > 0
      ) {
        let listFile = await FileApi.list({
          limit: res.result.file_dinh_kem_ids.length,
          filters: "id:in:" + res.result.file_dinh_kem_ids.join(",")
        });
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.map(item => {
            item.url = ExtensionService.urlImg + item.id;
          });
        }
        this.mData.fileUploadOption.FileDinhKem.fileList = data;
      }
      this.fn_getListTourById(res.result.tour_id);
      let resTourApi = await TourApi.findById(res.result.tour_id);
      if (resTourApi.result != undefined) {
        if (resTourApi.result.thoi_gian_bat_dau) {
          this.mData.dataDefault.thoi_gian_bat_dau_tour =
            resTourApi.result.thoi_gian_bat_dau;
        }
        if (resTourApi.result.thoi_gian_ket_thuc) {
          this.mData.dataDefault.thoi_gian_ket_thuc_tour =
            resTourApi.result.thoi_gian_ket_thuc;
        }
      }
      this.mData.dataForm = res.result;
    },
    async fn_initDataDefault() {
    },

    async fn_selectData(id) {
      if (id) {
        let reqTourApi = TourApi.findById(id);
        let resTourApi = await reqTourApi;
        this.mData.dataDefault.thoi_gian_bat_dau_tour =
          resTourApi.result.thoi_gian_bat_dau;
        this.mData.dataDefault.thoi_gian_ket_thuc_tour =
          resTourApi.result.thoi_gian_ket_thuc;
        this.mData.dataForm.thoi_gian_bat_dau =
          resTourApi.result.thoi_gian_bat_dau;
        this.mData.dataForm.thoi_gian_ket_thuc =
          resTourApi.result.thoi_gian_ket_thuc;
      } else {
        this.mData.dataForm.thoi_gian_bat_dau = "";
        this.mData.dataForm.thoi_gian_ket_thuc = "";
      }
    },

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    //upload file
    fn_uploadCheckFileSize(file, size) {
      return MethodService.checkFileSize(file, size);
    },

    fn_uploadRemoveFileDinhKem(file, fileList) {
      let data = [];
      fileList.forEach((el) => {
        data.push(el.id);
      });
      this.mData.dataForm.file_dinh_kem_ids = data;
    },
    fn_uploadChangeFileDinhKem(file, fileList) {
      ExtensionService.upload(file, "phieuDieuTour")
        .then(res => {
          this.mData.dataForm.file_dinh_kem_ids.push(res.result);
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.FileDinhKem.fileList = fileList;
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedFileDinhKem() {
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.FileDinhKem.limit} file`
      );
    },
    fn_uploadPreviewFileDinhKem(file) {
      this.mData.fileUploadOption.FileDinhKem.dialogImageUrl = file.url;
      this.mData.fileUploadOption.FileDinhKem.dialogVisible = true;
      window.open(ExtensionService.urlFile + file.id);
    },

    async fn_remoteGetListTour(query) {
      query = query.trim();
      
      if (query && query.length > 0) {
        
        let query1 = query
          .replace("*", "\\*")
          .replace("$", "\\$")
          .replace("%", "\\*")
          .replace("[", "\\[")
          .replace("]", "\\]")
          .replace("^", "\\^");
        let resTourApi = await TourApi.list({
          limit: 1000,
          filters: `ten_tour:regex_i:${query1}`
        });
        this.mData.dataDefault.listTour = resTourApi.result;
      }
    },
    async fn_getListTourById(id) {
      if (id) {
        let resTourApi = await TourApi.list({
          limit: 10,
          filters: `id=${id}`
        });
        this.mData.dataDefault.listTour = resTourApi.result;
      }
    },

    async fn_remoteGetListHuongDanVien(query) {
      this.mData.dataDefault.textFindHuongDanVien = query;
    },
    async fn_enterFindHuongDanVien() {
      if (this.mData.dataDefault.textFindHuongDanVien) {
        this.mData.dataDefault.textFindHuongDanVien = this.mData.dataDefault.textFindHuongDanVien.trim();
        let resHuongDanVienApi = await HuongDanVienApi.list({
          filters: `the_hdv.trang_thai=true&the_hdv.so_the=${encodeURIComponent(this.mData.dataDefault.textFindHuongDanVien)}`
        });
        this.mData.dataDefault.listHuongDanVien = resHuongDanVienApi.result;
      }
      this.mData.dataDefault.textFindHuongDanVien = "";
    },
    async fn_remoteGetListHuongDanVien2(query) {
      this.mData.dataDefault.textFindHuongDanVien2 = query;
    },
    async fn_enterFindHuongDanVien2() {
      if (this.mData.dataDefault.textFindHuongDanVien2) {
        this.mData.dataDefault.textFindHuongDanVien2 = this.mData.dataDefault.textFindHuongDanVien2.trim();
        let resHuongDanVienApi = await HuongDanVienApi.list({
          filters: `the_hdv.trang_thai=true&giay_to.so_giay_to=${encodeURIComponent(this.mData.dataDefault.textFindHuongDanVien2)}`
        });
        this.mData.dataDefault.listHuongDanVien2 = resHuongDanVienApi.result;
      }
      this.mData.dataDefault.textFindHuongDanVien2 = "";
    },

    fn_addHuongDanVien(item) {
      if (item) {
        item.ngay_sinh.ngay_sinh = new Date(
          item.ngay_sinh.nam,
          item.ngay_sinh.thang - 1,
          item.ngay_sinh.ngay
        ).toJSON();
        var flag = false;
        this.mData.dataDefault.listHuongDanVienTable.forEach((element) => {
            if (item.id == element.id) {
              flag = true;
            }
          }
        );
        this.mData.dataDefault.listHuongDanVienDaXacNhan.forEach((element) => {
            if (item.id == element.id) {
              flag = true;
            }
          }
        );
        if (flag) {
          window.toastr.info("Đã tồn tại Hướng Dẫn Viên này");
        } else {
          this.mData.dataDefault.listHuongDanVienTable.push(item);
          this.mData.dataForm.huong_dan_vien_cho_xac_nhan_ids.push(item.id);
        }
        this.mData.dataDefault.itemHuongDanVien = null;
        this.mData.dataDefault.listHuongDanVien = [];
        this.mData.dataDefault.itemHuongDanVien2 = null;
        this.mData.dataDefault.listHuongDanVien2 = [];
      }
    },
    fn_deleteHuongDanVien(index) {
      this.$confirm(LanguageService.lang.c_deleteConfirm, {
        confirmButtonText: LanguageService.lang.c_agree,
        cancelButtonText: LanguageService.lang.c_cancel,
        type: "warning"
      })
        .then(() => {
          var itemDel = this.mData.dataDefault.listHuongDanVienTable[index];
          this.mData.dataDefault.listHuongDanVienTable.splice(index, 1);
          this.mData.dataForm.huong_dan_vien_cho_xac_nhan_ids.forEach((item, i) => {
              if (itemDel.id == item) {
                this.mData.dataForm.huong_dan_vien_cho_xac_nhan_ids.splice(i, 1);
                return false; // breaks
              }
            }
          );
        })
        .catch(() => {});
    }
  },
  created: function() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {
    console.log("mData.dataForm.tour_id",this.mData.dataForm);
  }
};
</script>
<style lang="scss">
.el-select-dropdown__wrap {
    // max-width: 320px;
}
.el-autocomplete.inline-input{
  width: 100%;
}
</style>